/* CF山梨: トップのメインビジュアル スライドショー(Step11)
   - スライドが2枚以上のときだけ起動。クロスフェードで切替
   - 自動送り(設定ON時)・矢印・ドット・スワイプ・ホバー/フォーカスで一時停止
   - 安全策: 1枚 or JS失敗時は CSSの :first-child が先頭スライドを表示(何もしない)
   - reduced-motion: 自動送りはせず、手動操作(矢印/ドット/スワイプ)のみ有効
   - タブ非表示・画面外では自動送りを止める。二重初期化をガード */
(function () {
  if (window.__cfHeroInit) return;
  window.__cfHeroInit = true;

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(root) {
    try {
      var slides = Array.prototype.slice.call(root.querySelectorAll('.cf-hero__slide'));
      if (slides.length < 2) return; // 1枚は静止(CSSが表示)

      var dots = Array.prototype.slice.call(root.querySelectorAll('.cf-hero__dot'));
      var prev = root.querySelector('.cf-hero__nav--prev');
      var next = root.querySelector('.cf-hero__nav--next');
      var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduce;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      if (interval < 3000) interval = 3000;

      var current = 0;
      var timer = null;
      var inView = true;

      function show(i) {
        var n = slides.length;
        current = ((i % n) + n) % n;
        slides.forEach(function (s, idx) {
          var on = idx === current;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        dots.forEach(function (d, idx) {
          var on = idx === current;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      function nextSlide() { show(current + 1); }
      function prevSlide() { show(current - 1); }

      function start() {
        if (!autoplay || timer || !inView || document.hidden) return;
        timer = window.setInterval(nextSlide, interval);
      }
      function stop() {
        if (timer) { window.clearInterval(timer); timer = null; }
      }
      function restart() { stop(); start(); }

      // JSが制御を引き取る(CSSの既定表示を上書き)
      root.setAttribute('data-cf-ready', '');
      show(0);

      if (next) next.addEventListener('click', function () { nextSlide(); restart(); });
      if (prev) prev.addEventListener('click', function () { prevSlide(); restart(); });
      dots.forEach(function (d, idx) {
        d.addEventListener('click', function () { show(idx); restart(); });
      });

      // ホバー/フォーカスで一時停止
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      // スワイプ(横方向のみ)
      var sx = 0, sy = 0, tracking = false;
      var vp = root.querySelector('.cf-hero__viewport') || root;
      vp.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
      }, { passive: true });
      vp.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) nextSlide(); else prevSlide();
          restart();
        }
      }, { passive: true });

      // 画面外・タブ非表示では止める
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            inView = en.isIntersecting;
            if (inView) start(); else stop();
          });
        }, { threshold: 0.2 });
        io.observe(root);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      start();
    } catch (e) {
      /* 失敗してもCSSの先頭スライドは表示される */
    }
  }

  function boot() {
    document.querySelectorAll('.cf-hero').forEach(initHero);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
